import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ListHeader from "./list-header";
import ListBody from "./ListBody";

const List = ({ items, selectUserGroup, newUserGroup, deleteObject, company, }) => {
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    setFilteredList(items);
  }, [items]);

  const onFilterList = (filterName) => {
    if (filterName.length > 0) {
      const filteredList = items.filter((item) => {
        return item.name.toLowerCase().includes(filterName.toLowerCase());
      });
      setFilteredList(filteredList);
    } else {
      setFilteredList(items);
    }
  };

  return (
    <ListContainer>
      <ListHeader newUserGroup={newUserGroup} filterFunction={onFilterList} />
      <ListBody 
      company={company} 
      items={filteredList} 
      selectUserGroup={selectUserGroup} 
      deleteObject={deleteObject}/>
    </ListContainer>
  );
};

const ListContainer = styled.div`
  width: 100%;
`;

export default List;
